// src/api.js

// This placeholder will be replaced by a script when the Docker container starts.
// It allows us to set the API URL at runtime.
const API_BASE_URL = "__VITE_API_BASE_URL__";

/**
 * Constructs a full API URL from a given path.
 * @param {string} path - The endpoint path, e.g., "/promotions/active"
 * @returns {string} The full URL, e.g., "http://localhost:8080/promotions/active"
 */
export function getApiUrl(path) {
  // Ensure the path starts with a slash for consistency
  const formattedPath = path.startsWith('/') ? path : `/${path}`;
  
  // Handle the case where the placeholder hasn't been replaced during local dev
  if (API_BASE_URL.startsWith('__VITE_')) {
    console.warn("API_BASE_URL placeholder not replaced. Falling back to localhost:8080 for local development.");
    return `http://localhost:8080${formattedPath}`;
  }

  return `${API_BASE_URL}${formattedPath}`;
}

// --- STRATEGY CHANGE: Centralized Stripe Configuration ---
// If the environment variable fails to load (common in some dev environments),
// fall back to this hardcoded string.
// WARNING: Only use a TEST key here. Never hardcode a live production key.
const STRIPE_PUBLISHABLE_KEY = "__VITE_STRIPE_PUBLISHABLE_KEY__";
export function getStripeUrl() {
  if (STRIPE_PUBLISHABLE_KEY.startsWith('__VITE_')) {
    return "pk_test_51MqJrxHUBq3or9mH9wNV7Kbz7XdtZLhWMuQPaEhNiZ8upfGqC4760VbW77tUOP4Z5yZog12dkqNmj6RmeSbKqB9200geaZn7Op";
  }
  return STRIPE_PUBLISHABLE_KEY;
}


